
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';
import TextBox from './../../zviz2/zviz/components/textbox';
import {extend} from './../../zviz2/zviz/functions';
import config from './../../config';
import {styleWords} from './../../styles';
//import {LifeCycle} from './../zviz2/zviz/cycle';



class ActiveFilterController extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.filter = false;

    }

    init(renderer){
        super.init(renderer);
        if(! this.data || (! this.data.filter && ! this.filter)){
            console.warn('Please provide the name of the filter');
        }
    }

    getFilterName(){
        return this.data.filter;
    }
    

    hasFilters(){
        let filter = this.getFilter(this.getFilterName());
        return (filter.length > 0);
    }

    getFilter(name){
        let filter = state.get('filter.' + name);
        if(! filter){
            return [];
        }
        if(! (filter instanceof Array)){
            filter = [filter];
        }
        return filter;
    }

    getChildren(){
        let filter = this.getFilter(this.getFilterName());
        let result = [];
        for(let f of filter){
            result.push(extend({
                properties: {
                    data: {name: this.data.filter, value: f}
                }
            }, BlueprintFilter));
        }
        if(result.length > 0 && this.data.includeSeparator){
            result.push(extend({}, BlueprintSeparator));
        }

        return result;
    }

    formatValue(input){
        if(input instanceof Object){
            if(input instanceof Array){
                return '[List(' + input.join(', ') + ')]';
            }else{
                return '[Structured object]'
            }
        }
        return input;
    }

    
    deleteFilter(name, value){

        let filter = this.getFilter(name);
        let result = [];
        for(let f of filter){
            if(value !== f){
                result.push(f);
            }
        }
        if(result.length==0){
            result = null;
        }
        state.set('filter.'+this.getFilterName(), result);
    }

    getFontSize(){
        return '8pt';
    }

}


let Blueprint = extend({
    type: ActiveFilterController,
    properties: {
        style: { 
            marginBottom: (ctrl) => ( ctrl.hasFilters()? '10px': '' ) 
        },
        data: {
            filter: '',
            includeSeparator: false
        }
    },
    children: [ (ctrl) => ( ctrl.getChildren() ) ]
}, Group);


let BlueprintFilter = extend({
    properties:{
        style: {
            height: '25px',
            backgroundColor: '#f7f3ef',
            position: 'relative',
            marginTop: '3px',
        },
        data: {
            name: '',
            value: ''
        }
    },
    children: [
        extend({
            properties:{
                style: extend({
                    fontSize: (ctrl) => ( ctrl.parent.parent.getFontSize() ),
                    lineHeight: '25px',
                    padding: '0px 25px 0px 5px',
                    height: '25px',
                    overflow: 'hidden'
                }, styleWords),
                content: (ctrl) => ( ctrl.parent.parent.formatValue(ctrl.parent.data.value) )
            }
        }, TextBox),

        extend({
            properties: {
                style:{
                    position: 'absolute',
                    display: 'block',
                    width: '25px',
                    height: '25px',
                    top: '0px',
                    right: '0px',
                    background: 'transparent url(\'' + config.imgPath + 'delete_filter.png\') center center no-repeat'
                }
            },
            events: {
                click: (event, ctrl) => { ctrl.parent.parent.deleteFilter(ctrl.parent.data.name, ctrl.parent.data.value); }
            }
        }, Link)
    ]
}, Group);

let BlueprintSeparator = extend({
    properties: {
        style: {
            position: 'relative',
            left: '50%',
            marginLeft: '-75px',
            width: '150px',
            height: '7px',
            borderBottom: '1px solid #d3d3d3'
        }
    }
}, Group);

export default Blueprint;
export {ActiveFilterController as Controller, Blueprint};
